<template>
  <div>
    <!-- 底部图标 -->
    <div class="icon-box">
      <div class="content pt-10 flex between items-center">
        <div class="item flex items-center">
          <img src="../assets/images/gpngping.png" alt="" />
          <span class="ml-20 text">公平公正</span>
        </div>
        <div class="item flex items-center">
          <img src="../assets/images/kuaijie.png" alt="" />
          <span class="ml-20 text">方便快捷</span>
        </div>
        <div class="item flex items-center">
          <img src="../assets/images/jiaoyi.png" alt="" />
          <span class="ml-20 text">阳光交易</span>
        </div>
        <div class="item flex items-center">
          <img src="../assets/images/hezuo.png" alt="" />
          <span class="ml-20 text">诚信合作</span>
        </div>
      </div>
    </div>

    <!-- 登录尾部 -->
    <div class="footer">
      <!-- <div class="content flex between items-center">
        <div class="logo flex items-center">
          <img src="../assets/images/logo.png" style="width: 100%" alt="" />
        </div>
        <div class="rizhi">
          <h4 class="h4">操作指南</h4>
          <div>
            <p
              class="p"
              v-for="item in caoZuoList"
              :key="item.id"
              @click="downZhiNan(item.manualUrl)"
            >
              {{ item.manualName }}
            </p>
          </div>
        </div>
        <div class="erweima flex">
          <div class="img-box">
            
            二维码
          </div>
          <div class="ml-15 flex flex-column between">
            <div class="size14 info">
              扫一扫 <br />
              浏览移动端页面
            </div>
            <div class="copy">
              Copyright © 2012-2021 TAIYUAN NETWORK TECHNOLOGY CO., LTD.
            </div>
          </div>
        </div>
      </div>  -->
      <div class="content flex items-center">
        <div class="left">
          <h2>联系我们</h2>
          <p>邮箱：{{ footerInfo.officicalEmail }}</p>
			<p>固定电话：{{ footerInfo.telphone }}</p>
          <p>手机：15513625276</p>
          <p>地址：{{ footerInfo.concatAddress }}</p>
        </div>
        <!-- 中 -->
        <div class="center flex">
<!--          <div>
            <h2>操作手册</h2>
            <p
              class="pointer"
              v-for="item in caoZuoList"
              @click="downZhiNan(item.manualUrl)"
              :key="item.id"
            >
              {{ item.manualName }}
            </p>
          </div> -->
		<div>
			<h2 class="ml-30" style="text-align: center;margin-bottom: 10px;">小程序</h2>
			<img class="ml-30" src="../assets/images/qrcode.png" alt="" />
		</div>
        </div>
        <!-- 右 -->
        <div class="right">
          <p>版权所有：山西筑创科技有限公司</p>
		<!-- <p>版权所有</p> -->
          <p>备案号：晋ICP备19013707号</p>
          <p>技术支持：山西图灵未来科技有限公司</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Footer",
  data() {
    return {
      caoZuoList: [],
      footerInfo: {},
    };
  },
  mounted() {
    this.getCaoZuoZhiNan();
    this.getFooterInfo();
  },
  methods: {
    downZhiNan(fill) {
      // window.open("http://81.70.253.119:8081" + fill);
      let url = fill.slice(fill.indexOf("/profile/upload") + 15);
      // window.open("http://81.70.253.119:8081/common/download?fileName=" + url);
	  window.open(this.$static.serverUrl + "/common/download?fileName=" + url);
    },
    async getCaoZuoZhiNan() {
      const { data: res } = await this.$axios.get(
        "/api/platInfo/getManualInfo",
        {
          params: {
            type: 1,
          },
        }
      );
      if (res.code == 200) {
        this.caoZuoList = res.data.slice(0, 4);
      } else {
        this.$message.closeAll();
        this.$message.error(res.msg);
      }
    },
    //获取网站信息
    async getFooterInfo() {
      const { data: res } = await this.$axios.get("/api/platInfo/getPlatInfo");
      console.log(res);
      if (res.code == 200) {
        this.footerInfo = res.data;
      }
    },
  },
};
</script>

<style scoped lang="less">
//底部图标
.icon-box {
  height: 90px;
  background-color: #e7edf5;
  .content {
    width: 1200px;
    margin: 0 auto;
    .item {
      .text {
        font-size: 18px;
        color: #1c65c4;
      }
    }
  }
}
.footer {
  background-color: #1c65c4;
  padding: 50px 0;
  .content {
    width: 1200px;
    margin: 0 auto;
    color: #fff;
    font-size: 16px;
    padding-right: 50;
    box-sizing: border-box;
    p {
      line-height: 2em;
    }
    .left {
      padding-right: 50px;
      h2 {
        margin-bottom: 10px;
      }
    }
    .right {
      padding-top: 20px;
      padding-left: 50px;
    }
    .center {
      margin: 0 100px;
      img {
        width: 120px;
        height: 120px;
      }
    }
  }
}
</style>